import React, { useState } from 'react'

import * as S from './styles'
import {
  DoctorRegisterStatus,
  DoctorRegisterStepStatus
} from 'domain/entities/doctor-register'
import {
  translateDoctorRegisterStepStatusForDirector,
  translateDoctorRegisterStepStatusforHospital
} from 'presentation/utils/translators/doctor-register-step-status'
import { newRegistrationDetailsContext } from '../../../../layouts/DoctorRegister/NewRegistrationsDetails/context'
import { observer } from 'mobx-react'

const hospitalStatuses = ['Pendente', 'Aprovado']
const directorStatuses = ['Revisão', 'Aprovado']

type SelectPendencyStatusProps = {
  initialValue: DoctorRegisterStepStatus
  handleChange(actualPendencyStatus: string): void
  disabled?: boolean
  options?: string[]
  isDirector?: boolean
}

const SelectPendencyStatus = observer(
  ({
    initialValue,
    handleChange,
    disabled,
    isDirector = false,
    options = isDirector ? directorStatuses : hospitalStatuses
  }: SelectPendencyStatusProps) => {
    const value = isDirector
      ? translateDoctorRegisterStepStatusForDirector(initialValue)
      : translateDoctorRegisterStepStatusforHospital(initialValue)

    const { activeStatusRegister } = newRegistrationDetailsContext

    const [actualPendencyStatus, setActualPendencyStatus] = useState(
      value ?? ''
    )

    const onchangePendencyStatus = (value: any) => {
      setActualPendencyStatus(value.target.value)
      handleChange(value)
      return value
    }

    return (
      <S.Wrapper>
        {activeStatusRegister !==
          DoctorRegisterStatus.REGISTER_RESEND_TO_DIRECTOR &&
          (!actualPendencyStatus || actualPendencyStatus === 'Em análise') && (
            <S.NoStatusSelected>Insira o status</S.NoStatusSelected>
          )}
        {actualPendencyStatus === 'Alterado' && (
          <S.PendencyStatus pendencyStatus={'Alterado'}>
            Alterado
          </S.PendencyStatus>
        )}
        {!isDirector && actualPendencyStatus === 'Revisão' && (
          <S.PendencyStatus pendencyStatus={'Revisão'}>
            Revisão
          </S.PendencyStatus>
        )}

        {isDirector &&
          activeStatusRegister ===
            DoctorRegisterStatus.REGISTER_RESEND_TO_DIRECTOR &&
          actualPendencyStatus === 'Em análise' && (
            <S.PendencyStatus pendencyStatus={'Alterado'}>
              Alterado
            </S.PendencyStatus>
          )}
        <S.StyledSelect
          variant="outlined"
          value={
            actualPendencyStatus === 'Aprovado' ||
            actualPendencyStatus === 'Pendente' ||
            actualPendencyStatus === 'Revisão'
              ? actualPendencyStatus
              : actualPendencyStatus === 'Aprovado pelo diretor'
              ? 'Aprovado'
              : ''
          }
          defaultValue={''}
          onChange={onchangePendencyStatus}
          disabled={disabled}
        >
          {options?.map((pendency) => (
            <S.StyledMenuItem key={pendency} value={pendency}>
              <S.PendencyStatus pendencyStatus={pendency}>
                {pendency}
              </S.PendencyStatus>
            </S.StyledMenuItem>
          ))}
        </S.StyledSelect>
      </S.Wrapper>
    )
  }
)

export default SelectPendencyStatus
